import { render, staticRenderFns } from "./DetailedInformation.vue?vue&type=template&id=0543cf90&scoped=true"
import script from "./DetailedInformation.vue?vue&type=script&lang=js"
export * from "./DetailedInformation.vue?vue&type=script&lang=js"
import style0 from "./DetailedInformation.vue?vue&type=style&index=0&id=0543cf90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543cf90",
  null
  
)

export default component.exports